import React, { useState, useEffect } from 'react';

import {useTranslation} from "react-i18next";

const CountdownTimer = ({ targetDate }) => {
    const {t} = useTranslation();
    const calculateTimeLeft = () => {
        const difference = +new Date(targetDate) - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                totalSeconds: Math.floor(difference / 1000),
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearTimeout(timer);
    });

    const { days, hours, minutes, seconds } = timeLeft;

    const formatTime = (val) => {
        return val < 10 ? `0${val}` : val;
    };

    return (
        <div className="text-uppercase">
            {days > 0 ? `${days} ${t('DAY')} : ` : ''}
            {formatTime(hours)} {t('HOURS')} : {formatTime(minutes)} {t('MINUTES')} : {formatTime(seconds)} {t('SECONDS')}
        </div>
    );
};

export default CountdownTimer;
